export const SET_PARTNER_DEALER_COMPANIES_FILTER = 'SET_PARTNER_DEALER_COMPANIES_FILTER'
export const SET_PARTNER_COMPANIES_FILTER = 'SET_PARTNER_COMPANIES_FILTER'
export const SET_PARTNER_COMPANIES = 'SET_PARTNER_COMPANIES'
export const APPEND_PARTNER_COMPANIES = 'APPEND_PARTNER_COMPANIES'
export const SET_PARTNER_COMPANIES_TOTALS = 'SET_PARTNER_COMPANIES_TOTALS'
export const SET_PARTNER_COMPANIES_LENGTH = 'SET_PARTNER_COMPANIES_LENGTH'
export const SET_PARTNER_COMPANIES_IS_LOADING = 'SET_PARTNER_COMPANIES_IS_LOADING'
export const SET_PARTNER_FILTER = 'SET_PARTNER_FILTER'
export const SET_PARTNER_DATE_PERIOD_TYPE = 'SET_PARTNER_DATE_PERIOD_TYPE'
export const SET_PARTNER_CLIENTS_REPORTS_MODAL = 'SET_PARTNER_CLIENTS_REPORTS_MODAL'
export const SET_PARTNER_DEALER_PROVISION = 'SET_PARTNER_DEALER_PROVISION'
export const SET_PARTNER_CLIENTS_REPORTS = 'SET_PARTNER_CLIENTS_REPORTS'
export const APPEND_PARTNER_CLIENTS_REPORTS = 'APPEND_PARTNER_CLIENTS_REPORTS'
export const SET_PARTNER_CLIENTS_REPORTS_LENGTH = 'SET_PARTNER_CLIENTS_REPORTS_LENGTH'
export const SET_PARTNER_DEALER_REPORT_DATA = 'SET_PARTNER_DEALER_REPORT_DATA'
export const SET_PARTNER_DEALER_REPORT_DATE_FROM = 'SET_PARTNER_DEALER_REPORT_DATE_FROM'
export const SET_PARTNER_DEALER_REPORT_DATE_TO = 'SET_PARTNER_DEALER_REPORT_DATE_TO'
export const SET_PARTNER_MORE_COMPANIES_IS_LOADING = 'SET_PARTNER_MORE_COMPANIES_IS_LOADING'
export const SET_PARTNER_SHOW_CALENDAR = 'SET_PARTNER_SHOW_CALENDAR'
export const SET_SHOW_PARTNER_DEALERS_CHECKBOX = 'SET_SHOW_PARTNER_DEALERS_CHECKBOX'
export const SET_PARTNER_INCLUDE_PARTNER_DEALERS = 'SET_PARTNER_INCLUDE_PARTNER_DEALERS'
export const SET_PARTNER_PROLONGATION = 'SET_PARTNER_PROLONGATION'
export const SET_PARTNER_DEACTIVATION_STRIPE_DATA = 'SET_PARTNER_DEACTIVATION_STRIPE_DATA'
export const UPDATE_PARTNER_COMPANIES = 'UPDATE_PARTNER_COMPANIES'
export const SET_PARTNER_COMPANY_DATA = 'SET_PARTNER_COMPANY_DATA'
export const SET_PARTNER_COMPANY_INDEX = 'SET_PARTNER_COMPANY_INDEX'
export const SET_PARTNER_DEALER_REPORT_WITH_COMPENSATION_DATA = 'SET_PARTNER_DEALER_REPORT_WITH_COMPENSATION_DATA'
export const SET_PARTNER_DEALER_PROVISION_WITH_COMPENSATION = 'SET_PARTNER_DEALER_PROVISION_WITH_COMPENSATION'
export const SET_PARTNER_SHOW_COMPANY_DATA_MODAL = 'SET_PARTNER_SHOW_COMPANY_DATA_MODAL'
export const SET_PARTNER_SHOW_INVOICES_MODAL = 'SET_PARTNER_SHOW_INVOICES_MODAL'
export const SET_PARTNER_FRANCHISES_LENGTH = 'SET_PARTNER_FRANCHISES_LENGTH'
export const SET_PARTNER_FRANCHISES = 'SET_PARTNER_FRANCHISES'
export const APPEND_PARTNER_FRANCHISES = 'APPEND_PARTNER_FRANCHISES'
export const SET_PARTNER_FRANCHISES_TOTALS = 'SET_PARTNER_FRANCHISES_TOTALS'
export const SET_PARTNER_ACTIVE_TAB = 'SET_PARTNER_ACTIVE_TAB'
export const SET_PARTNER_SHOW_FRANCHISE_FILIALS = 'SET_PARTNER_SHOW_FRANCHISE_FILIALS'
export const SET_PARTNER_FRANCHISES_FILTER = 'SET_PARTNER_FRANCHISES_FILTER'
export const UPDATE_PARTNER_FRANCHISES = 'UPDATE_PARTNER_FRANCHISES'

